module.exports = __webpack_public_path__ + "static/media/welding.beb1b49f.png";